import styles from '@/styles/promotionBox.module.scss'
import Link from 'next/link'
import Image from 'next/image'
import { useState, useEffect } from 'react'
import { Timer } from '@/utils/countDown'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import useCartActions from '@/utils/addTocartAction'
import { getToken } from '@/utils/auth'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

dayjs.extend(duration)

interface PromotionProps {
  preSales: number;
  preSalesDate: string
  currentTime: string;
  quantityNum: number;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    discountPercent: string;
    ebaySync: number;
  };
  emailOnlyFinished: number;
  crazyDeal: {
    hoursLeft: number;
    minutesLeft: number;
    secondsLeft: number;
  } | undefined
}

export default function PromotionBox({ preSales, preSalesDate, currentTime, quantityNum, promotion, emailOnlyFinished, crazyDeal }: PromotionProps) {
  const { addToCart } = useCartActions();
  // 检测是否为Firefox浏览器
  const isFirefox = typeof window !== 'undefined' && window.navigator.userAgent.toLowerCase().includes('firefox');

  let timer = new Timer()
  interface TimeRemaining {
    days: number,
    hours: string,
    minutes: string,
    seconds: string,
    isEnd: boolean,
  }

  // 倒计时计算
  const [days, setDays] = useState(0)
  const [preSalesDateFormat, setPreSalesDateFormat] = useState('')
  const [timeDetail, setTimeDetail] = useState<string[]>([])
  function countDown(times: Date | number) {
    timer.countDown(times, (timeRemaining: TimeRemaining) => {
      if (timeRemaining.isEnd) { // 倒计时结束了
        let isPromotionEnd = currentTime < promotion.endDate
        console.log(isPromotionEnd, ' == isPromotionEnd => reload');
                
        if (isPromotionEnd || promotion.promotionType == 1) {
          location.reload()
        }
      } else { // 正在倒计时
        let timeDetail: string[] = []
        const { days, hours, minutes, seconds, isEnd } = timeRemaining
        if (isEnd) return
        let hh: string | number = days * 24 + parseInt(hours)
        if (hh <= 99) {
          hh < 10 ? hh = '0' + hh : hh = `${hh}`
          const [h1, h2] = hh.split('')
          timeDetail.push(h1, h2)
        } else {
          timeDetail.push('9', '9')
        }
        const [m1, m2] = minutes.split('')
        const [s1, s2] = seconds.split('')
        timeDetail = [...timeDetail, m1, m2, s1, s2]
        setTimeDetail(timeDetail)
      }
    })
  }

  useEffect(() => {
    // csotd, 从数据返回拿
    if (
      !preSales 
      && promotion.promotionType == 1
      && (crazyDeal?.hoursLeft || crazyDeal?.minutesLeft || crazyDeal?.secondsLeft)
    ) {
      setDays(days)
      // 结束时间
      const time = new Date().getTime() + (60 * 60 * crazyDeal.hoursLeft + 60 * crazyDeal.minutesLeft + crazyDeal.secondsLeft) * 1000
      countDown(time)
      
    } else {
      // 预售：获取preSalesDate, 然后格式化
      if (preSales && preSalesDate) {
        setPreSalesDateFormat(dayjs(preSalesDate).format('DD/MM/YYYY'))
        return
      }

      // 这些类型不需要倒计时
      if (promotion.promotionType == 4 || promotion.promotionType == 99 || emailOnlyFinished) return
    }
  }, [])

  // 为TimeLeft专门做的倒计时
  // 初始状态
  const initialTimeRemaining: TimeRemaining = {
    days: 0,
    hours: '00',
    minutes: '00',
    seconds: '00',
    isEnd: false,
  }
  const [timeLeft, setTimeLeft] = useState<TimeRemaining>(initialTimeRemaining)

  // 保存当前时间的时间戳
  const [pageStaySecend, setPageStaySecend] = useState(1);
  const [timeLeftEnd, setTimeLeftEnd] = useState(true);

  useEffect(() => {
    if (
      promotion.promotionType != 2 &&
      promotion.promotionType != 3 &&
      promotion.promotionType != 6
    ) {
      return;
    }

    const calculateTimeLeft = () => {
      const endDateObj = dayjs(promotion.endDate);
      const currentTimeObj = dayjs.unix(dayjs(currentTime).unix() + pageStaySecend);
      const timeDifference = endDateObj.diff(currentTimeObj);

      if (timeDifference <= 0) {
        // Countdown ends
        setTimeLeft({ days: 0, hours: '00', minutes: '00', seconds: '00', isEnd: true });
        setTimeLeftEnd(true);
        console.log('Countdown ends');
      } else {
        const days = endDateObj.diff(currentTimeObj, 'day');
        const hours = String(endDateObj.diff(currentTimeObj, 'hour') % 24).padStart(2, '0');
        const minutes = String(endDateObj.diff(currentTimeObj, 'minute') % 60).padStart(2, '0');
        const seconds = String(endDateObj.diff(currentTimeObj, 'second') % 60).padStart(2, '0');

        setTimeLeftEnd(false);
        setTimeLeft({ days, hours, minutes, seconds, isEnd: false });
        setPageStaySecend(pageStaySecend + 1);
      }
    };

    // 在组件挂载时开始第一个定时器
    if (
      promotion.promotionType != 2 &&
      promotion.promotionType != 3 &&
      promotion.promotionType != 6
    ) {
      return;
    }

    setTimeout(() => {
      calculateTimeLeft()
    }, 1000);
  }, [pageStaySecend]);


  // PRE-ORDER NOW
  function preOrderNow() {
    const href = encodeURIComponent(`/checkout?p=${promotion.productID}&t=${quantityNum}`)
    if (getToken() == '1') {
      window.location.href = `/checkout?p=${promotion.productID}&t=${quantityNum}`
    } else {
      window.location.href = `/login?redirect=${href}`
    }
  }

  // 加入购物车的回调
  const addToCartCallBack = (response: any) => {
    if (response != "error") {
      window.location.href = '/view-cart'
    }
  }

  return (
    <>
      {
        preSales
        ?
        // Presale
        <div className={styles['promotion-box']}>
          <div className={styles['promotion-pc']}>
            <div className={styles['presale-title']}>
              <Image
                className={styles['title-img']}
                src={`${imageDomain}/product-detail/presale.png`}
                alt={'presale'}
                width={318}
                height={70}></Image>

              <div className={styles['title-content']}>
                <div className={styles['title']}>Estimated Shipping On</div>
                <div className={styles['date']}>{ preSalesDateFormat }</div>
                <div className={styles['desc']}>This is a PRE-ORDER item</div>
              </div>
            </div>

            <div className={styles['content']}>
              <div className={styles['text']}>
                <b>CRAZY INTRODUCTORY OFFER!</b>&nbsp;
                Now only&nbsp;
                <span className={styles['price']}>${promotion.promotionPrice}!</span>&nbsp;
                <span 
                  className={styles['link']}
                  onClick={preOrderNow}
                >
                  PRE-ORDER NOW
                </span>
              </div>
              <div className={`${styles['text']} padding-top-6`}>
                *Shipped timeframe is an estimated of when the item order will ship from our warehouse. <br/>
                The items you have ordered will be shipped as soon as they become available.
              </div>
            </div>
          </div>

          <div
            className={styles['promotion-ipad']}
            style={{ 
              background: `url('${imageDomain}/product-detail/ipad-presale.jpg') no-repeat`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              paddingTop: '20px'
              }}
          >

            <div className={styles['presale-ipad-title']}>
              <div className={styles['desc-left']}>
                Estimated<br />Shipping On
              </div>
              
              <div className={styles['presale-date']}>
                { preSalesDateFormat }
              </div>

              <div className={styles['desc-right']}>
                This is a<br />PRE-ORDER item
              </div>
            </div>

            <div className={`${styles['promotion-ipad-desc']} margin-top-6`}>
              <b>CRAZY INTRODUCTORY OFFER!</b>Now only: <b>${promotion.promotionPrice}!</b>
            </div>

            <div className={styles['promotion-ipad-desc']}>
              Offer only valid while supplies last! &nbsp;
              <span 
                className={styles['link']}
                onClick={preOrderNow}
              >
                PRE-ORDER NOW
              </span>
            </div>

            <div className={`${styles['promotion-ipad-tips']}`}>
              *Shipped timeframe is an estimated of when the item order will ship from our warehouse. <br />
              The items you have ordered will be shipped as soon as they become available.
            </div>
          </div>
        </div>
        :
        <>
          {/* Csotd */}
          {(promotion.promotionType == 1 && timeDetail.length > 0) && (
            <div className={styles['promotion-box']}>
              <div className={styles['promotion-pc']}>
                <div className={styles['csotd-title']}>
                  <Image
                    className={styles['title-img']}
                    src={`${imageDomain}/product-detail/csotd.png`}
                    alt={'csotd'}
                    width={318}
                    height={70}></Image>

                  <div className={styles['title-content']}>
                    Crazy Sale<br/>of the Day
                  </div>
                </div>

                <div className={styles['content']}>
                  <div className={styles['text']}>
                    <b>Time Left: </b>
                    <div className={styles['count-down']}>
                      <div 
                        className={styles['count-down-item']}
                        style={{ lineHeight: isFirefox ? '44px': '40px' }}
                      >
                        {timeDetail[0]}
                      </div>
                      <div 
                        className={styles['count-down-item']}
                        style={{ lineHeight: isFirefox ? '44px': '40px' }}
                      >
                        {timeDetail[1]}
                      </div>
                      :
                      <div 
                        className={`${styles['count-down-item']} margin-left-4`}
                        style={{ lineHeight: isFirefox ? '44px': '40px' }}
                      >
                        {timeDetail[2]}
                      </div>
                      <div 
                        className={styles['count-down-item']}
                        style={{ lineHeight: isFirefox ? '44px': '40px' }}
                      >
                        {timeDetail[3]}
                      </div>
                      :
                      <div 
                        className={`${styles['count-down-item']} margin-left-4`}
                        style={{ lineHeight: isFirefox ? '44px': '40px' }}
                      >
                        {timeDetail[4]}
                      </div>
                      <div 
                        className={styles['count-down-item']}
                        style={{ lineHeight: isFirefox ? '44px': '40px' }}
                      >
                        {timeDetail[5]}
                      </div>
                    </div>
                    For 24 Hours Only. Grab Now!
                  </div>
                </div>
              </div>

              <div
                className={styles['promotion-ipad']}
                style={{ 
                  background: `url('${imageDomain}/product-detail/ipad-csotd.jpg') no-repeat`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                 }}
              >
                <div className={styles['promotion-ipad-title']}>
                  Crazy Sale of the Day
                </div>

                <div className={`${styles['promotion-ipad-desc']} margin-top-6`}>
                  <b>TIME LEFT: </b>
                </div>

                <div className={`${styles['promotion-ipad-countdown']} margin-top-4`}>
                  <div 
                    className={styles['countdown-item']}
                    style={{ lineHeight: isFirefox ? '44px': '40px' }}
                  >
                    {timeDetail[0]}
                  </div>
                  <div 
                    className={styles['countdown-item']}
                    style={{ lineHeight: isFirefox ? '44px': '40px' }}
                  >
                    {timeDetail[1]}
                  </div>
                  :
                  <div 
                    className={styles['countdown-item']}
                    style={{ lineHeight: isFirefox ? '44px': '40px' }}
                  >
                    {timeDetail[2]}
                  </div>
                  <div 
                    className={styles['countdown-item']}
                    style={{ lineHeight: isFirefox ? '44px': '40px' }}
                  >
                    {timeDetail[3]}
                  </div>
                  :
                  <div 
                    className={styles['countdown-item']}
                    style={{ lineHeight: isFirefox ? '44px': '40px' }}
                  >
                    {timeDetail[4]}
                  </div>
                  <div 
                    className={styles['countdown-item']}
                    style={{ lineHeight: isFirefox ? '44px': '40px' }}
                  >
                    {timeDetail[5]}
                  </div>
                </div>

                <div 
                  className={`${styles['promotion-ipad-desc']} margin-top-6`}
                  style={{ fontSize: '16px' }}
                >
                  For 24 Hours Only. Grab Now!
                </div>
              </div>
            </div>
          )}

          {/* Time Left  */}
          {!!((promotion.promotionType == 2 || promotion.promotionType == 3 || promotion.promotionType == 6) && !timeLeftEnd) && (
            <div className={styles['promotion-box']}>
              <div className={styles['promotion-pc']}>
                <div className={styles['time-left-title']}>
                  <Image
                    className={styles['title-img']}
                    src={`${imageDomain}/product-detail/time-left.png`}
                    alt={'time-left'}
                    width={318}
                    height={70}></Image>

                  <div className={styles['title-content']}>
                    <div className={styles['time-left-text']}>TIME<br />LEFT:</div>

                    <div className={styles['time-left-content']}>
                      <div className={styles['count-down']}>
                        <div className={styles['count-down-num']}>{timeLeft.days || 0}</div>&nbsp;days&nbsp;<div className={styles['count-down-num']}>
                          {timeLeft.hours[0] || 0}
                          {timeLeft.hours[1] || 0}:
                          {timeLeft.minutes[0] || 0}
                          {timeLeft.minutes[1] || 0}:
                          {timeLeft.seconds[0] || 0}
                          {timeLeft.seconds[1] || 0}
                          </div>
                      </div>
                      <div className={styles['date']}>Promotion ends on {dayjs(promotion.endDate).format('DD/MM/YYYY')}</div>
                    </div>
                  </div>
                </div>

                {
                  (promotion.promotionType == 2) &&
                  <div className={styles['content']}>
                    <div className={styles['text']}>
                      <b>CRAZY DISCOUNT!</b>&nbsp;
                      Was: ${promotion.normalPrice} Now:&nbsp;
                      <span className={styles['price']}>${promotion.promotionPrice}!</span>&nbsp;
                      Limited time offer and while supplies last!&nbsp;
                      <span
                        className={styles['link']}
                        onClick={(event) => {
                          addToCart(event, { 
                            productID: promotion.productID,
                            qty: 1,
                          }, addToCartCallBack) }}
                      >
                        BUY NOW
                      </span>
                    </div>
                    <div className={`${styles['text']} padding-top-6`}>
                      *This offer is only valid when checkout is completed within the indicated promotion time.
                    </div>
                  </div>
                }
                
                {
                  (promotion.promotionType == 3) &&
                  <div className={styles['content']}>
                    <div className={styles['text']}>
                      <b>GET EXTRA SAVINGS with Free Shipping!</b>&nbsp;
                      For a limited time only,while supplies last! &nbsp;
                      <span className={styles['link']}>SAVE NOW!</span>
                    </div>
                    <div className={`${styles['text']} padding-top-6`}>
                      *This offer is only valid when checkout is completed within the indicated promotion time.
                    </div>
                  </div>
                }
                
                {
                  (promotion.promotionType == 6) &&
                  <div className={styles['content']}>
                    <div className={styles['text']}>
                      <b>Email Only.</b>&nbsp;
                      Was: ${promotion.normalPrice} (Crazy Price)&nbsp;Now:&nbsp;
                      <span className={styles['price']}>${promotion.promotionPrice}!</span>&nbsp;(Email Price)
                    </div>
                    <div className={`${styles['text']} padding-top-6`}>
                      * Email Only Price for all the Newsletter Subscribers who open the Email.
                    </div>
                    <div className={`${styles['text']} padding-top-6`}>
                      Click&nbsp;
                      <Link
                        href={`/newsletters?email=Email+Address`}
                        legacyBehavior
                      >
                        <a rel="noopener noreferrer"><b>here</b></a>
                      </Link>
                      &nbsp;to subscribe our newsletter for more Savings
                    </div>
                  </div>
                }
              </div>

              <div
                className={styles['promotion-ipad']}
                style={{ 
                  background: `url('${imageDomain}/product-detail/ipad-timeleft.jpg') no-repeat`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                 }}
              >
                <div className={styles['time-left-box']}>
                  <div className={styles['time-left-title']}>TIME<br />LEFT:</div>
                  <div className={styles['days-countdown']}>{timeLeft.days || 0}</div>
                  <div className={styles['days-text']}>Days</div>

                  <div 
                    className={`${styles['promotion-ipad-countdown']}`}
                    style={{ margin: 'inherit'}}
                  >
                    <div className={styles['countdown-item']}>{timeLeft.hours[0] || 0}</div>
                    <div className={styles['countdown-item']}>{timeLeft.hours[1] || 0}</div>
                    :
                    <div className={styles['countdown-item']}>{timeLeft.minutes[0] || 0}</div>
                    <div className={styles['countdown-item']}>{timeLeft.minutes[1] || 0}</div>
                    :
                    <div className={`${styles['countdown-item']} ${styles['countdown-black']}`}>{timeLeft.seconds[0] || 0}</div>
                    <div className={styles['countdown-item']}>{timeLeft.seconds[1] || 0}</div>
                  </div>
                </div>

                <div className={styles['promotion-end-date']}>
                  Promotion ends on {dayjs(promotion.endDate).format('DD/MM/YYYY')}
                </div>

                {
                  (promotion.promotionType == 2) &&
                  <>
                    <div className={`${styles['promotion-ipad-desc']} margin-top-6`}>
                      <b>CRAZY DISCOUNT!</b>&nbsp;
                      Was: ${promotion.normalPrice} Now: <b>${promotion.promotionPrice}!</b>
                    </div>

                    <div className={styles['promotion-ipad-desc']}>
                      Limited time offer and while supplies last!&nbsp;
                      <span
                        className={styles['link']}
                        onClick={(event) => {
                          addToCart(event, { 
                            productID: promotion.productID,
                            qty: 1,
                          }, addToCartCallBack) }}
                      >
                        BUY NOW
                      </span>
                    </div>

                    <div className={`${styles['promotion-ipad-tips']} margin-top-4`}>
                      *This offer is only valid when checkout is completed within the indicated promotion time.
                    </div>
                  </>
                }
                
                {
                  (promotion.promotionType == 3) &&
                  <>
                    <div className={`${styles['promotion-ipad-desc']} margin-top-6`}>
                      <b>GET EXTRA SAVINGS with Free Shipping!</b>&nbsp;
                    </div>

                    <div className={styles['promotion-ipad-desc']}>
                      For a limited time only,while supplies last! &nbsp;
                      <span
                        className={styles['link']}
                        onClick={(event) => {
                          addToCart(event, { 
                            productID: promotion.productID,
                            qty: 1,
                          }, addToCartCallBack) }}
                      >
                        SAVE NOW!
                      </span>
                    </div>

                    <div className={`${styles['promotion-ipad-tips']} margin-top-4`}>
                      *This offer is only valid when checkout is completed within the indicated promotion time.
                    </div>
                  </>
                }
                
                {
                  (promotion.promotionType == 6) &&
                  <>
                    <div className={`${styles['promotion-ipad-desc']} margin-top-6`}>
                      <b>Email Only.</b>&nbsp;
                      Was: ${promotion.normalPrice} Now: <b>${promotion.promotionPrice}!</b>
                    </div>

                    <div className={styles['promotion-ipad-desc']}>
                      * Email Only Price for all the Newsletter Subscribers who open the Email.
                    </div>

                    <div className={styles['promotion-ipad-desc']}>
                      Click&nbsp;
                      <Link
                        href={`/newsletters?email=Email+Address`}
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer"><b>here</b></a>
                      </Link>
                      &nbsp;
                      to subscribe our newsletter for more Savings
                    </div>
                  </>
                }
              </div>
            </div>
          )}

          {/* Clearance */}
          {(promotion.promotionType == 4) && (
            <div className={styles['promotion-box']}>
              <div className={styles['promotion-pc']}>
                <div className={styles['clearance-title']}>
                  <Image
                    className={styles['title-img']}
                    src={`${imageDomain}/product-detail/clearance.png`}
                    alt={'clearance'}
                    width={318}
                    height={70}></Image>

                  <div className={styles['title-content']}>
                    HURRY! <br/>Limited Stock!
                  </div>
                </div>

                <div className={styles['content']}>
                  <div className={styles['text']}>
                    <b>ONLY A FEW LEFT!</b>&nbsp;
                    Was: ${promotion.normalPrice} Now:&nbsp;
                    <span className={styles['price']}>${promotion.promotionPrice}!</span>&nbsp;
                    Offer only valid while supplies last!&nbsp;
                    <span 
                      className={styles['link']}
                      onClick={(event) => {
                        addToCart(event, { 
                          productID: promotion.productID,
                          qty: 1,
                        }, addToCartCallBack) 
                      }}
                    >
                      BUY NOW
                    </span>
                  </div>
                  <div className={`${styles['text']} padding-top-6`}>
                    *This offer is only valid when checkout is completed within the indicated promotion time.
                  </div>
                </div>
              </div>

              <div
                className={styles['promotion-ipad']}
                style={{ 
                  background: `url('${imageDomain}/product-detail/ipad-clearance.jpg') no-repeat`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                 }}
              >
                <div className={styles['promotion-ipad-title']}>
                  HURRY! Limited Stock!
                </div>

                <div className={`${styles['promotion-ipad-desc']} margin-top-6`}>
                  <b>ONLY A FEW LEFT! </b>Was: ${promotion.normalPrice} Now: <b>${promotion.promotionPrice}!</b>
                </div>

                <div className={styles['promotion-ipad-desc']}>
                  Offer only valid while supplies last! &nbsp;
                  <span
                    className={styles['link']}
                    onClick={(event) => {
                      addToCart(event, { 
                        productID: promotion.productID,
                        qty: 1,
                      }, addToCartCallBack) }}
                  >
                    BUY NOW
                  </span>
                </div>

                <div className={`${styles['promotion-ipad-tips']} margin-top-16`}>
                  *This offer is only valid when checkout is completed within the indicated promotion time.
                </div>
              </div>
            </div>
          )}

          {/* Csotd后一天 */}
          {(promotion.promotionType == 99) && (
            <div className={styles['promotion-box-csotd-day-after']}>
              <div className={styles['promotion-pc']}>
                <Image
                  className={styles['background-img']}
                  src={`${imageDomain}/product-detail/csotd-day-after.png`}
                  alt={'csotd-day-after'}
                  width={1198}
                  height={70}></Image>

                <div className={styles['content']}>
                  <div className={styles['text']}>
                    <span className={styles['blod-text']}>Price Drop!</span>&nbsp;
                    Was: ${promotion.normalPrice} Now:&nbsp;
                    <span className={styles['price']}>${promotion.promotionPrice}!</span>&nbsp;
                    <Link
                      href={`/newsletters/index`}
                      legacyBehavior
                    >
                      <a className={styles['link']} rel="noopener noreferrer">Join our newsletter</a>
                    </Link>&nbsp;
                    to get advanced notice of special promotions.
                  </div>
                  <div className={`${styles['text']} padding-top-6`}>
                    *This offer is only valid when checkout is completed within the indicated promotion time.
                  </div>
                </div>
              </div>

              <div
                className={styles['promotion-ipad']}
                style={{ 
                  background: `url('${imageDomain}/product-detail/ipad-csotd-last.jpg') no-repeat`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                 }}
              >
                <div className={styles['promotion-ipad-title']}>
                  Price Drop
                </div>

                <div className={`${styles['promotion-ipad-desc']} margin-top-6`}>
                  Was: ${promotion.normalPrice} Now: <b>${promotion.promotionPrice}!</b>
                  &nbsp;
                  <Link
                    href={`/newsletters/index`}
                    legacyBehavior
                  >
                    <a
                      className={styles['link']}
                      rel="noopener noreferrer"
                    >
                      Join our newsletter
                    </a>
                  </Link>&nbsp;
                  to
                </div>

                <div className={styles['promotion-ipad-desc']}>
                  get advanced notice of special promotions.
                </div>

                <div className={`${styles['promotion-ipad-tips']} margin-top-16`}>
                  *This offer is only valid when checkout is completed within the indicated promotion time.
                </div>
              </div>
            </div>
          )}

          {/* emial Only 结束 */}
          {(!!emailOnlyFinished) && (
            <div className={styles['email-only-end']}>
              Email Only Price has ended! Click&nbsp;
              <Link
                href={`/newsletters?email=Email+Address`}
                legacyBehavior
              >
                <a rel="noopener noreferrer"><b style={{ color: '#D90B17' }}>here</b></a>
              </Link>
              &nbsp;to subscribe our newsletter for more Savings
            </div>
          )}
        </>
      }
    </>
  )
}